/* eslint-disable max-classes-per-file */
export class DataAutologin {
  accountId: number;

  utmId: number;

  isCorporate: number;

  constructor(data: any) {
    this.accountId = data?.accountId || 0;
    this.utmId = data?.utmId || 0;
    this.isCorporate = data?.isCorporate || 0;
  }
}

export class ResponseGetAutoLogin {
  status: boolean;

  code?: string;

  message: string;

  data: DataAutologin;

  constructor(data: any) {
    this.status = data?.status || false;
    this.code = data?.code || "";
    this.message = data?.message || "";
    this.data = new DataAutologin(data?.data);
  }
}
